import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import SideNav from "./sidenav";
import Header from "./header";
import Back from "../assets/images/arrow2.png";
import camera2 from "../assets/images/camera2.png";
import { toast } from "react-toastify";
import { addBranch } from "../redux/actions/branchAction";
import { useBranchValidation } from "../hooks/useBranchValidation";

const BranchAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { storeData } = useSelector((store) => store.store);

  const initialFormState = {
    branchName: "",
    phoneNumber: "",
    address: "",
    city: "",
    lat: "",
    long: "",
    managerName: "",
    loginEmail: "",
    password: "",
    bannerImage: null,
    logo: "",
  };

  const {
    formData,
    errors,
    isUploading,
    validateBranch,
    handleChange,
    handleInput,
    handleSelect,
    handleImageChange,
    autocomplete: { ready, value, status, data },
  } = useBranchValidation(initialFormState, false);

  const ref = React.useRef(null);
  const [showPassword, setShowPassword] = React.useState(true);

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li
          key={place_id}
          onClick={handleSelect(suggestion)}
          style={{
            cursor: "pointer",
            padding: "12px 16px",
            listStyle: "none",
            borderBottom: "1px solid #f1f3f5",
            transition: "all 0.2s ease",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f8f9fa";
            e.currentTarget.style.paddingLeft = "20px";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.paddingLeft = "16px";
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "#e8f0fe",
              color: "#1a73e8",
              flexShrink: 0,
              transition: "transform 0.2s ease",
            }}
          >
            <i className="fa fa-map-marker" style={{ fontSize: "16px" }}></i>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              overflow: "hidden",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#333",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {main_text}
            </span>
            {secondary_text && (
              <span
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              >
                {secondary_text}
              </span>
            )}
          </div>
        </li>
      );
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateBranch()) {
      return;
    }

    const storeId =
      storeData?.data?._id ||
      JSON.parse(localStorage.getItem("storeDetailsId")) ||
      JSON.parse(localStorage.getItem("ownerLogin"))?._id;

    const payload = {
      storeName: `${storeData?.data?.storeName}-${formData.branchName}`,
      address: formData.address,
      city: formData.city || "Riyadh",
      mobileNumber: formData.phoneNumber,
      email: formData.loginEmail,
      password: formData.password,
      banner: formData.logo || "",
      lat: Number(formData.lat) || 24.7136,
      long: Number(formData.long) || 46.6753,
      managerName: formData.managerName,
    };

    dispatch(addBranch(payload))
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.message || "Branch added successfully", {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/branch-management");
        } else {
          toast.error(res.message || "Failed to add branch", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((err) => {
        toast.error(err.message || "Something went wrong", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <>
      <Header />
      <SideNav />
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <div>
              <h4 className="Title">
                <Link to="/branch-management">
                  <img src={Back} alt="Back" />
                </Link>
                Add Branch
              </h4>
            </div>
          </div>

          <div className="Small-Wrapper">
            <div
              style={{
                backgroundColor: "#f0f7ff",
                border: "1px solid #d0e3f8",
                padding: "15px 20px",
                borderRadius: "8px",
                display: "flex",
                gap: "15px",
                marginBottom: "30px",
                color: "#3a6d99",
              }}
            >
              <i
                className="fa fa-code-branch"
                style={{ fontSize: "20px", marginTop: "2px" }}
              ></i>
              <p style={{ margin: "0", fontSize: "14px", lineHeight: "1.5" }}>
                This branch belongs to{" "}
                <strong>{storeData?.data?.storeName || "RUGA ROKO"}</strong>. It
                inherits the parent's menu/items. Branch staff can only
                hide/unhide items by availability — they cannot add or edit
                items. New branches are{" "}
                <strong>submitted to the admin for approval</strong> before
                going live.
              </p>
            </div>

            <div className="CommonForms">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <div className="UploadImages">
                    {isUploading ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "300px",
                          width: "300px",
                          border: "2px dashed #003a6b",
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <div
                          className="spinner-border text-primary"
                          role="status"
                          style={{
                            width: "3rem",
                            height: "3rem",
                            marginBottom: "15px",
                            color: "#003a6b",
                          }}
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                        <h6 style={{ color: "#003a6b", margin: 0 }}>
                          Uploading image...
                        </h6>
                      </div>
                    ) : formData.bannerImage ? (
                      <img
                        src={URL.createObjectURL(formData.bannerImage)}
                        style={{
                          width: "300px",
                          height: "300px",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                        alt="Banner Preview"
                      />
                    ) : (
                      <>
                        <img src={camera2} alt="Upload" />
                        <h6>Add Branch images</h6>
                      </>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      disabled={isUploading}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Branch name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="branchName"
                        value={formData.branchName}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={`${storeData?.data?.storeName || "Store"} —`}
                        required
                      />
                      {errors.branchName && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.branchName}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Parent store</label>
                      <input
                        type="text"
                        value={`${storeData?.data?.storeName || "Store"}`}
                        disabled
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        Phone number <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Branch phone"
                        required
                      />
                      {errors.phoneNumber && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.phoneNumber}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div
                      className="form-group"
                      style={{ position: "relative" }}
                    >
                      <label>
                        Address <span style={{ color: "red" }}>*</span>
                      </label>
                      <div ref={ref}>
                        <input
                          type="text"
                          name="address"
                          value={formData.address || value}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Start typing to search the address..."
                          required
                        />
                        {errors.address && (
                          <span style={{ color: "red", fontSize: "12px" }}>
                            {errors.address}
                          </span>
                        )}
                        {status === "OK" && (
                          <ul
                            style={{
                              position: "absolute",
                              zIndex: 999,
                              width: "100%",
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: 0,
                              margin: "4px 0 0 0",
                              maxHeight: "200px",
                              overflowY: "auto",
                              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                            }}
                          >
                            {renderSuggestions()}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>
                        City <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        className="form-control"
                        placeholder="City"
                        required
                        readOnly
                      />
                      {errors.city && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.city}
                        </span>
                      )}
                    </div>
                  </div>

                  <div
                    className="col-sm-12"
                    style={{ marginTop: "20px", marginBottom: "10px" }}
                  >
                    <h4
                      style={{
                        margin: "0",
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#333",
                        borderBottom: "1px solid #eee",
                        paddingBottom: "10px",
                        marginBottom: "20px",
                      }}
                    >
                      Branch Login Credentials
                    </h4>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>
                        Manager name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="managerName"
                        value={formData.managerName}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Full name"
                        required
                      />
                      {errors.managerName && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.managerName}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>
                        Login email <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        name="loginEmail"
                        value={formData.loginEmail}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="branch@store.com"
                        required
                      />
                      {errors.loginEmail && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.loginEmail}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label>
                        Password <span style={{ color: "red" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          type={showPassword ? "password" : "text"}
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Password"
                          required
                          style={{ paddingRight: "45px" }}
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            position: "absolute",
                            top: "50%",
                            transform: "translateY(-50%)",
                            right: "15px",
                            fontSize: "16px",
                            color: "#6c757d",
                            cursor: "pointer",
                            zIndex: 10,
                          }}
                        >
                          <i
                            className={
                              showPassword ? "fa fa-eye-slash" : "fa fa-eye"
                            }
                          ></i>
                        </span>
                      </div>
                      {errors.password && (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errors.password}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="ButtonMain mt-4">
                  <Link
                    to="/branch-management"
                    className="Button"
                    style={{
                      width: "auto",
                      marginRight: "15px",
                      backgroundColor: "#fff",
                      color: "#003a6b",
                      border: "1px solid #003a6b",
                      borderRadius: "4px",
                      padding: "8px 24px",
                      fontWeight: "600",
                      transition: "all 0.2s ease",
                      display: "inline-block",
                      textDecoration: "none",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#e6effa";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#fff";
                    }}
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    className="Button AddButton"
                    style={{
                      borderRadius: "4px",
                      padding: "8px 24px",
                      fontWeight: "600",
                      backgroundColor: "#003a6b",
                      color: "#fff",
                      border: "none",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#002b50";
                      e.target.style.boxShadow =
                        "0 4px 12px rgba(0, 58, 107, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#003a6b";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BranchAdd;
